import { useQuery } from "@tanstack/react-query";
import { qk } from "#/lib/queryKeys";
import { ArticleRevisionListItem, listArticleRevisions } from "#/services/articles";

export function useArticleRevisions(articleId?: string) {
  return useQuery<ArticleRevisionListItem[]>({
    queryKey: articleId ? qk.articleRevisions(articleId) : qk.articles(),
    queryFn: () => {
      if (!articleId) {
        return Promise.reject(new Error("Article id is required"));
      }
      return listArticleRevisions(articleId);
    },
    enabled: Boolean(articleId),
    staleTime: 15_000,
  });
}

export default useArticleRevisions;
